import PrivacyPolicyPage from '../PrivacyPolicy/PrivacyPolicy';

const PrivacyPage = () => {
  return (
    <>
      <PrivacyPolicyPage />
    </>
  );
};

export default PrivacyPage;
